<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Mihret Adal Gidi is a young novelist emerging from East Africa, based in Addis Ababa, Ethiopia. She is known for being a strong fighter and someone who doesn’t give up. She has always dreamt of being an author, and she was praised because of her potential by her teachers while in high school. She finally mustered up her courage to complete <em>Bleeding Hearts of a Butterfly</em> for publication during her study at Kotobe University College.</p>
<p>She’s currently working on the sequel of this book and a new horror story among many others.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?53d07f2f